export const isFullStatic = false
export const staticPath = "/root/project/frontend/.nuxt/static-json"
export const publicPath = "https://frontenddev.builtin.com/cfced2490cf3816f205c242850c0dfb201251e08/"
export const globalContext = "__NUXT__"
export const globalNuxt = "$nuxt"